import React from 'react';
import Lottie from 'react-lottie';

import { getSystemSettings } from '../../../../utils/SettingsRetriever';

import animationData from './animation.json';

import './index.scss';

export default function SnowingAnimation(props) {
    const System = getSystemSettings();
    
    let animation = animationData;
    
    if (System.app.animationColor) {
        if (System.app.animationColor.length !== 7) {
            if (process.env.NODE_ENV === 'development') {
                throw Error('Animation color is not a valid value!');
            }
        } else {
            const finalColor = System.app.animationColor.substr(1);
            
            const colorR = parseInt(finalColor.substr(0,2), 16) / 255;
            const colorG = parseInt(finalColor.substr(2,2), 16) / 255;
            const colorB = parseInt(finalColor.substr(4,2), 16) / 255;
            
            // very awesome hack to change color on *this* lottie
            animation.layers[0].shapes[0].it[2].c.k = [colorR, colorG, colorB, 1];
        }
    }
    
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <React.Fragment>
            <div className="loadingAnimation">
                <div className="circle">
                    <Lottie options={defaultOptions}
                        height={300}
                        width={300}
                        isStopped={false}
                        isPaused={false}
                        className="lottie"
                        isClickToPauseDisabled={true}
                    />
                    <img src={props.logo} alt={System.head.title} />
                </div>
            </div>
        </React.Fragment>
    )
}
